var config = {};

// 获取当前登录用户
config['me'] = function () {
};

// 快捷回复消息
config['msg-shortcut'] = [
  /*'能见面交易？',
   '亲，包邮吗？',
   '价格还可以商量？',
   '你好，这个职位还在招人吗？',
   '你好，这套房源租出去了吗？'*/
];
//用户名片
config['user-contactinfo'] = [
  '发送我的联系方式',
  '索取TA的联系方式'
]

// 消息转换器，将消息结构转换成相应ui的标准结构
config['msg-show-converter'] = function (msg) {
  return msg;
};

// 发送消息转换器，将内部标准消息结构转换成发送需要的结构
config['msg-send-converter'] = function (msg) {
  return msg;
};

// 会话上展示的消息转换器
config['session-msg-converter'] = function (msg) {
  return null;
};
// 是否显示头像
config['msg-avatar'] = true;

// 埋点统计
config['stat'] = {
  appversion: '1.0',
  appid: '',
  appkey: '',
  cookiename: 'webimwmda',
  pn: 'default',
  reportIntervalTime: 15,
  reportIntervalCount: 1
};

// 最大化页面地址
config['maxUrl'] = 'javascript:void(0);';

// 组织结构&搜索
config['organization'] = {
  enabled: false,
  getDetailByGroup: function (group_id, cb) {
    cb([]);
  },
  search: function (keyword, cb) {
    cb([]);
  }
};

// 消息声音提醒
config['msg-sound'] = 'https://wx.qq.com/zh_CN/htmledition/v2/sound/msg.mp3';

// 默认头像
config['default-avatar'] = 'https://pic1.58cdn.com.cn/p1/n_v1bkuymc2tsxlfo5wrgb7a.png';

// 默认游客头像
config['default-anonymous-avatar'] = 'https://img.58cdn.com.cn/git/teg-app-fe/im-images/default-images/avatar/anonymous-avatar@2x.png';

//默认卡片图片
config['default-card-img'] = 'https://pic3.58cdn.com.cn/nowater/webim/big/n_v1bl2lwxtpeksfrr3aea3q.png';

// 获取用户信息
config['getUserinfo'] = function () {
};

// 获取用户业务方相关信息
config['getContactDetailInfo'] = function (contact) {
  return null;
};
// 绑定手机号
config['bind-cellphone'] = function (success, fail) {
  fail();
};

// 跳转绑定手机号链接
config['get-bindcellphone-url'] = function () {
  return '';
};

// 信质弹窗
config['xz-source'] = '';

// session列表处理（如:将部分账号置顶）
config['sessions-converter'] = function (sessions, cb) {
  cb(sessions);
};

// 点击特定会话的操作
config['on-session-item-click'] = function (contact) {
  var isShowChatWin = true;
  return isShowChatWin;
};

// 默认会话列表引导文案
config['default-contactwindow'] = {
  img: 'https://pic3.58cdn.com.cn/nowater/webim/big/n_v24245011a3bdf4341a38d213a5cf76fbb.png',
  tip: '尚未和其他人聊天,请选择您中意的帖子,并与发布者交谈'
};
//语音
config['audio-converter'] = function (url) {
  var newUrl;
  // 对于已经转换过的语音链接，进行https转换
  if (typeof (url) === 'string' && url.indexOf('audioconvert.58.com') > -1) {
    if (url.indexOf('http://audioconvert.58.com') === 0) {
      newUrl = url.replace('http', 'https');
    } else if (url.indexOf('//audioconvert.58.com') === 0) {
      newUrl = 'https:' + url;
    } else if (url.indexOf('audioconvert.58.com') === 0) {
      newUrl = 'https://' + url;
    } else if (url.indexOf('https://audioconvert.58.com') === 0) {
      newUrl = url;
    }
  } else {
    newUrl = 'https://audioconvert.58.com/convert?amrurl=' + encodeURIComponent(url);
  }
  return newUrl;
};

// 默认iframe位置
config['normal-iframe-position'] = {
  right: 0,
  bottom: 0
};

// 音视频开关
config['is_show_audio_video'] = false;

// 各业务线对应的快捷回复
config['business-msg-shortcut'] = [
  {
    rootcateid: 0,
    cateid: 0,
    quickmsgs: ["你好", "在吗"]
  }, {
    rootcateid: 1,
    cateid: 0,
    quickmsgs: ["你好，请问房子还在么？", "您是房东，还是中介？", "价格还可以商量么？", "什么时候方便看房？"]
  }, {
    rootcateid: 574,
    cateid: 0,
    quickmsgs: ["你好，请问这个岗位现在还招人么？", "你好，简历已投，请关注", "请问有五险一金吗？", "请问什么时候可以面试？"]
  }, {
    rootcateid: 577,
    cateid: 0,
    quickmsgs: ["你好，请问这个岗位现在还招人么？", "你好，简历已投，请关注", "请问有五险一金吗？", "请问什么时候可以面试？"]
  }, {
    rootcateid: 4,
    cateid: 0,
    quickmsgs: ["你好，在么？", "你好，这辆车还在么？", "价格还可以商量么？", "什么时候方便看车？"]
  }, {
    rootcateid: 5,
    cateid: 0,
    quickmsgs: ["你好，东西还在吗？", "价格还可以商量吗？", "东西是几成新？", "有购买发票么？"]
  }, {
    rootcateid: 833,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 4279,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 968,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 495,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 92,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 187,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 143,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 534,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 526,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 1010,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 495,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 515,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 1009,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 1135,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 1006,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 1917,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 1008,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }, {
    rootcateid: 4278,
    cateid: 0,
    quickmsgs: ["你好，在吗？", "价格还可以商量吗？", "能见面交易吗？", "谢谢，我再看看！"]
  }
];

// 匿名折叠用户组信息
config['anonymous_group'] = {
  id: '1',
  is_anonymous_group: true,
  name: '游客留言',
  unread_show_type: 'rash',
  avatar: 'https://img.58cdn.com.cn/git/teg-app-fe/im-images/default-images/avatar/anonymous-group@2x.png'
}

// 消息提醒头像
config['message_reminder'] = {
  avatar: 'https://img.58cdn.com.cn/git/teg-app-fe/im-images/default-images/avatar/reminder@2x.png'
}


module.exports = config;